// extracted by mini-css-extract-plugin
export default {"container":"service_container__43X65","content":"service_content__uKIPV"};